import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=304aeadb&"
import script from "./pricing.vue?vue&type=script&lang=js&"
export * from "./pricing.vue?vue&type=script&lang=js&"
import style0 from "./pricing.vue?vue&type=style&index=0&id=304aeadb&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/opt/buildhome/repo/components/global/LoadingSpinner.vue').default,LogoCloud: require('/opt/buildhome/repo/components/global/LogoCloud.vue').default})
